import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Button, SxProps, Typography } from '@mui/material';
import { FC, MouseEventHandler } from 'react';

interface ExpandMoreButtonProps {
    sx?: SxProps;
    isExpanded: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
    text: string;
}

const ExpandMoreButton: FC<ExpandMoreButtonProps> = ({ isExpanded, onClick, sx, text }) => (
    <Button
        onClick={onClick}
        sx={{ color: 'text.disabled', fontWeight: 'medium', minWidth: 'auto', p: 0 }}
    >
        <Typography sx={{ alignItems: 'center', display: 'flex', ...sx }} variant="body2">
            {text}
            {isExpanded ? (
                <ExpandLessRoundedIcon fontSize="small" />
            ) : (
                <ExpandMoreRoundedIcon fontSize="small" />
            )}
        </Typography>
    </Button>
);

export default ExpandMoreButton;
